/**
 * Page shell for the Settings section (/settings): one tab per plugin config.
 * Each plugin has its own permission, so tabs only show for plugins the user
 * can access.
 */
import { DashboardResources } from '@src/types';
import SectionTabShell, { type SectionTab } from '@src/components/SectionTabShell';

export const SETTINGS_TABS: SectionTab[] = [
  { value: DashboardResources.ResalePlugins, label: 'Resale' },
  { value: DashboardResources.TradeinPlugins, label: 'Trade-in' },
  { value: DashboardResources.RecyclePlugins, label: 'Recycling' },
  { value: DashboardResources.RepairPlugins, label: 'Repair plugin' },
].map(({ value, label }) => ({ value, label, path: `/${value}`, resource: value }));

interface SettingsTabShellProps {
  /** Plugin resource name of the active tab, e.g. 'settings/plugins/resale'. */
  tab: string;
  children: React.ReactNode;
}

const SettingsTabShell = ({ tab, children }: SettingsTabShellProps) => (
  <SectionTabShell
    title="Settings"
    description="Configure how each Trove plugin behaves for your storefront and customers."
    tabs={SETTINGS_TABS}
    tab={tab}
  >
    {children}
  </SectionTabShell>
);

export default SettingsTabShell;
